export { RiskRecords as RiskRecordsTable } from './RiskRecords';
